import React, { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { Star } from 'lucide-react-native';

type StarRatingProps = {
  count?: number;
  size?: number;
  selectedColor?: string;
  unselectedColor?: string;
  defaultRating?: number;
  onFinishRating?: (rating: number) => void;
};

export function StarRating({
  count = 5,
  size = 20,
  selectedColor = '#FFD700',
  unselectedColor = '#D1D5DB',
  defaultRating = 0,
  onFinishRating,
}: StarRatingProps) {
  const [rating, setRating] = useState(defaultRating);

  useEffect(() => {
    setRating(defaultRating);
  }, [defaultRating]);

  const handlePress = (value: number) => {
    setRating(value);
    onFinishRating?.(value);
  };

  return (
    <View className="flex-row items-center justify-center gap-1">
      {Array.from({ length: count }).map((_, index) => {
        const value = index + 1;
        const filled = value <= rating;
        return (
          <Pressable
            key={value}
            onPress={() => handlePress(value)}
            hitSlop={6}
            accessibilityRole="button"
            accessibilityLabel={`Rate ${value} out of ${count}`}
          >
            <Star
              size={size}
              color={filled ? selectedColor : unselectedColor}
              fill={filled ? selectedColor : 'transparent'}
            />
          </Pressable>
        );
      })}
    </View>
  );
}
